import { render, staticRenderFns } from "./GasChart.vue?vue&type=template&id=89d7452e&"
import script from "./GasChart.vue?vue&type=script&lang=ts&"
export * from "./GasChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports